import { UiSchema } from '@rjsf/utils'
import omit from 'lodash/omit'

import { FormProperties } from '../imup/types'
import { OpeningGroup } from '../models/activeDrawable'

const oneSided = '1-SIDED'
const twoSided = '2-SIDED'

const interiorPonyWall = 'INTERIOR PONY WALL'
const exteriorPonyWall = 'EXTERIOR PONY WALL'
const partyWall = 'PARTY WALL'
const wallTypesWithoutStudSpacing = [
    'FOUNDATION WALL',
    'BLOCK INTERIOR CABINET OR VANITY WALL',
    'BLOCK EXTERIOR CABINET OR VANITY WALL',
    'BLOCK EXTERIOR WALL',
    'BLOCK FIRE WALL',
    'BLOCK FOUNDATION WALL',
    'BLOCK INTERIOR WALL',
    'BLOCK PARTY WALL',
]
const wallTypesForStudFurringWidth = [
    'BLOCK INTERIOR CABINET OR VANITY WALL',
    'BLOCK EXTERIOR CABINET OR VANITY WALL',
    'BLOCK EXTERIOR WALL',
    'BLOCK FIRE WALL',
    'BLOCK INTERIOR WALL',
    'BLOCK PARTY WALL',
]
const sillPlateTypes = ['FOUNDATION WALL', 'BLOCK FOUNDATION WALL', 'KNEE WALL', 'WALK OUT WALL']
const wallTypesWithSheathingSelections = [
    'EXTERIOR WALL',
    'EXTERIOR CABINET OR VANITY WALL',
    'EXTERIOR EWP WALL',
    'EXTERIOR PONY WALL',
    'KNEE WALL',
    'PARAPET WALL',
    'RADIUS EXTERIOR WALL',
    'WALK OUT WALL',
]

export const excludedFloorDepthWallTypes = [
    'BEARING WALL',
    'BLOCK EXTERIOR CABINET OR VANITY WALL',
    'BLOCK EXTERIOR WALL',
    'BLOCK FIRE WALL',
    'BLOCK FOUNDATION WALL',
    'BLOCK INTERIOR CABINET OR VANITY WALL',
    'BLOCK INTERIOR WALL',
    'BLOCK PARTY WALL',
    'FOUNDATION WALL',
    'INTERIOR CABINET OR VANITY WALL',
    'INTERIOR EWP WALL',
    'INTERIOR PONY WALL',
    'INTERIOR WALL',
    'PARTY WALL',
    'PERIMETER WALL',
    'RADIUS BEARING WALL',
    'RADIUS INTERIOR WALL',
]

const reworkedFurringStripsType = [...wallTypesForStudFurringWidth, 'BLOCK FOUNDATION WALL']

const reworkedOneSidedStudFurringWallTypes = [
    'BLOCK EXTERIOR CABINET OR VANITY WALL',
    'BLOCK EXTERIOR WALL',
    'BLOCK FIRE WALL',
    'BLOCK FOUNDATION WALL',
]

export const uiSchema: UiSchema = {
    classNames: 'GeneralForm',
    title: {
        classNames: 'general-form-title',
    },
    drywall: {
        'ui:placeholder': 'Select Drywall',
    },
    party_shaft_wall_assembly: {
        'ui:placeholder': 'Select Party Shaft Wall Assembly',
    },
    misc_wall_material: {
        'ui:title': 'Misc. Wall Material',
    },
    height: {
        'ui:placeholder': 'Enter Wall Height',
    },
    king_stud: {
        'ui:field': 'KingStudField',
        'ui:placeholder': 'Select King Stud',
    },
    floor_depth_above: {},
    shearwall: {
        'ui:field': 'ShearwallField',
        'ui:placeholder': 'Select Shearwall',
    },
    staggered_studs: {
        'ui:field': 'RadioButtons',
        'ui:options': {
            inline: true,
        },
    },
    insulation: {
        'ui:field': 'RadioButtons',
        'ui:options': {
            inline: true,
        },
    },
    furring_stud_strip_width_2: {
        'ui:title': 'Stud/Furring Width 2',
    },
    furring_stud_strip_width_1: {
        'ui:title': 'Stud/Furring Width 1',
    },
    furring_strip_width_2: {
        'ui:title': 'Furring Strip Width 2',
    },
    furring_strip_width_1: {
        'ui:title': 'Furring Strip Width 1',
    },
    // keep empty object to hide them when we switch to advanced settings tab
    wall_sheathing: {
        'ui:placeholder': 'None',
    },
    wall_sheathing_2: {},

    wall_sheathing_fire_rated: {
        'ui:field': 'SwitchField',
    },
    wall_sheathing_2_fire_rated: {
        'ui:field': 'SwitchField',
    },
    wall_sheathing_treated: {
        'ui:field': 'SwitchField',
    },
    wall_sheathing_2_treated: {
        'ui:field': 'SwitchField',
    },
    fire_rated_sheathing: {
        'ui:field': 'SwitchField',
    },
    double_studs: {
        'ui:field': 'RadioButtons',
        'ui:options': {
            inline: true,
        },
    },
    edge_panel_nailer: {
        'ui:field': 'RadioButtons',
        'ui:options': {
            inline: true,
        },
    },
    edge_panel_nailer_dimensions: {
        'ui:field': 'LumberDimensionsField',
    },
    type: {
        'ui:placeholder': 'Select Type',
    },
    floor_level: {
        'ui:placeholder': 'Select Floor Level',
    },
    size: {
        'ui:placeholder': 'Select Wall Size',
    },
    sill_plate: {
        'ui:field': 'DropdownField',
        'ui:placeholder': 'Select Sill Plate',
        'ui:options': {
            dropdownWithPlaceholder: true,
        },
    },
    sill_plate_2: {
        'ui:placeholder': 'Select Sill Plate',
    },
    sill_plate_3: {
        'ui:placeholder': 'Select Sill Plate',
    },
    bottom_plate: {
        'ui:placeholder': 'Select Bottom Plate',
    },
    bottom_plate_2: {
        'ui:placeholder': 'Select Bottom Plate',
    },
    bottom_plate_3: {
        'ui:placeholder': 'Select Bottom Plate',
    },
    plate_species: {
        'ui:placeholder': 'Select Plate Species',
    },
    plate_grade: {
        'ui:placeholder': 'Select Plate Grade',
    },
    stud_species: {
        'ui:placeholder': 'Select Stud Species',
    },
    stud_grade: {
        'ui:placeholder': 'Select Stud Grade',
    },
    stud_spacing: {
        'ui:placeholder': 'Select Stud Spacing',
    },
    stud_furring_width: {
        'ui:placeholder': 'Select Stud Furring Width',
    },
    version: {
        'ui:widget': 'hidden',
    },
    'ui:order': [
        'type',
        'party_shaft_wall_assembly',
        'drywall',
        'floor_level',
        'floor_level_other',
        'size',
        'height',
        'furring_strips',
        'furring_stud_strip_width_1',
        'furring_stud_strip_width_2',
        'furring_strip_width_1',
        'furring_strip_width_2',
        'stud_furring_width',
        'sill_plate',
        'sill_plate_2',
        'sill_plate_3',
        'bottom_plate',
        'bottom_plate_2',
        'bottom_plate_3',
        'plate_species',
        'plate_grade',
        'stud_species',
        'stud_grade',
        'stud_spacing',
        'king_stud',
        'shearwall',
        'misc_wall_material',
        'staggered_studs',
        'insulation',
        'double_studs',
        'edge_panel_nailer',
        'edge_panel_nailer_dimensions',
        'wall_sheathing',
        'wall_sheathing_2',
        'floor_depth_above',
        'fire_rated_sheathing',
        'wall_sheathing_fire_rated',
        'wall_sheathing_2_fire_rated',
        'wall_sheathing_treated',
        'wall_sheathing_2_treated',
    ],
}

const onValidate = () => {}

const onSubmit = (settings, formData): OpeningGroup['settings'] => {
    const newSettings = { ...settings, ...formData }

    const isBlockWallEnhancement = parseInt(newSettings.version ?? '') === 2

    if (newSettings.type !== interiorPonyWall && newSettings.type !== exteriorPonyWall) {
        newSettings.drywall = null
    }

    if (excludedFloorDepthWallTypes.includes(newSettings.type)) {
        delete newSettings['floor_depth_above']
    }
    if (
        newSettings.type !== interiorPonyWall &&
        newSettings.type !== exteriorPonyWall &&
        newSettings.type !== partyWall
    ) {
        newSettings.party_shaft_wall_assembly = null
    }

    if (wallTypesWithoutStudSpacing.includes(newSettings.type)) {
        newSettings.stud_spacing = null
    }

    // clean up bottom or sill plate base on a selected type
    if (sillPlateTypes.includes(newSettings.type)) {
        newSettings.bottom_plate = null
        newSettings.bottom_plate_2 = null
        newSettings.bottom_plate_3 = null
    } else {
        newSettings.sill_plate = null
        newSettings.sill_plate_2 = null
        newSettings.sill_plate_3 = null
    }

    if (!isBlockWallEnhancement && !wallTypesForStudFurringWidth.includes(newSettings.type)) {
        newSettings.stud_furring_width = null
        newSettings.furring_strips = null
        newSettings.furring_stud_strip_width_1 = null
        newSettings.furring_stud_strip_width_2 = null
    }

    if (isBlockWallEnhancement) {
        const version = parseInt(formData.version)

        if (!isNaN(version) && version >= 2) newSettings.stud_furring_width = null

        if (!reworkedFurringStripsType.includes(newSettings.type)) {
            newSettings.furring_strips = null
            newSettings.furring_stud_strip_width_1 = null
            newSettings.furring_stud_strip_width_2 = null
        } else if (![oneSided, twoSided].includes(newSettings.furring_strips)) {
            newSettings.furring_stud_strip_width_1 = null
            newSettings.furring_stud_strip_width_2 = null
        } else if (newSettings.furring_strips === oneSided) {
            newSettings.furring_stud_strip_width_2 = null
        }
    }

    if (
        !wallTypesWithSheathingSelections.includes(newSettings.type) &&
        (!newSettings.shearwalls || newSettings.shearwalls?.length === 0)
    ) {
        newSettings.wall_sheathing_fire_rated = null
    }

    if (newSettings.edge_panel_nailer === 'false') {
        newSettings.edge_panel_nailer_dimensions = null
    }

    return {
        ...newSettings,
        ...omit(newSettings, ['misc_wall_material']),
    }
}

const onUpdate = (previousFormData, formData) => {
    const version = parseInt(formData.version)

    if (isNaN(version) || !previousFormData) return formData

    const isPrevTypeOneSidedDefault = reworkedOneSidedStudFurringWallTypes.includes(previousFormData.type)
    const isCurTypeOneSidedDefault = reworkedOneSidedStudFurringWallTypes.includes(formData.type)

    if (isPrevTypeOneSidedDefault !== isCurTypeOneSidedDefault) {
        formData.furring_strips = isCurTypeOneSidedDefault ? oneSided : twoSided
    }

    return formData
}

const form: FormProperties = { uiSchema, onValidate, onSubmit, onUpdate }

export default form
